import { axiosNoAuth } from '../../config/axiosInstances';
import { Api_url } from '../../common/api_url';
import { API_XANO_BASE_URL } from '../../config/api_config';

export function getOurLearnersWorkAt(successCallback, errorCallback){
    return async function (dispatch) {
        try {
            let response = await axiosNoAuth.get(
                API_XANO_BASE_URL + Api_url.GetOurLearnersWorkAt
            )
            
            successCallback && successCallback(response.data);
        } catch (e) {
            console.error(e);
            errorCallback && errorCallback(e.response.data.message);
        }
    };
}

